import React from 'react';
import cn from 'classnames';
export const AccordionPanel = ({ children, open, panelId, classNamePanel, classNameContent, }) => (React.createElement("div", { className: cn('cb-accordion-panel transition', classNamePanel, open && 'cb-in'), role: "region", id: panelId },
    React.createElement("div", { className: cn('cb-accordion-panel-content', classNameContent) }, children)));
//# sourceMappingURL=AccordionPanel.js.map